import { CONTRACT_TYPES } from '../../Views/Contracts/contract_enums';

export const checkCorporateContract = contractType => {
  return [CONTRACT_TYPES.Industrial, CONTRACT_TYPES.Unregulated].includes(
    contractType
  );
};
